<template>
  <section class="cn-about-cards-section">
    <div class="container">
      <div class="cn-about-cards-section__top">
        <span class="cn-about-cards-section__title">
          {{ data.title }}
        </span>
        <div class="cn-about-cards-section__top-border"></div>
      </div>
      <div class="cn-about-cards-section__bottom">
        <div
          v-for="(col, i) in data.cols"
          :key="i"
          class="cn-about-cards-section__collumn"
        >
          <component
            :is="cardComponents[card.type]"
            v-for="(card, j) in col"
            :key="j"
            :color="card.color"
            :img="card.image && card.image.src"
            :title="card.title"
            :description="card.description"
            :link="card.link"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import AboutCard from './AboutCard.vue';
import AboutCardText from './AboutCardText.vue';

interface Props {
  data: {
    title: string;
    cols: Array<
      Array<{
        type: string;
        title?: string;
        description?: string;
        color?: string;
        image?: {
          src?: string;
        };
        link?: {
          text?: string;
          url?: string;
        };
      }>
    >;
  };
}
defineProps<Props>();

const cardComponents: Record<string, Component> = {
  'about-card': AboutCard,
  'about-card-text': AboutCardText,
};
</script>

<style lang="scss">
.cn-about-cards-section {
  --ab-canyon-about-cards-section-top-border-color-border: var(
    --ab-canyon-color-neutral
  );
  --ab-canyon-about-cards-section-title-color-text: var(
    --ab-canyon-color-neutral-dark
  );

  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);

  &__top {
    column-gap: var(--size-3xl);
    align-items: center;
    display: flex;
  }
  &__top-border {
    border-bottom-width: 1px;
    width: 100%;
    border-color: var(--ab-canyon-about-cards-section-top-border-color-border);
  }
  &__title {
    font-size: var(--text-s-font-size);
    line-height: var(--text-s-font-height);
    flex-shrink: 0;
    color: var(--ab-canyon-about-cards-section-title-color-text);
  }
  &__bottom {
    justify-content: space-between;
    flex-direction: column;
    display: flex;
    margin-top: var(--size-xl);
    margin-left: calc(var(--size-xs) * -1);
    margin-right: calc(var(--size-xs) * -1);
    @media (min-width: 656px) {
      flex-direction: row;
      margin-top: var(--size-5xl);
    }
  }
  &__collumn {
    padding-left: var(--size-xs);
    padding-right: var(--size-xs);
    @media (min-width: 656px) {
      max-width: 569px;
    }

    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-xl);
        @media (min-width: 1280px) {
          margin-top: 200px;
        }
      }
    }
  }
}
</style>
